import { VerificationCode } from 'ace-ui-eking'
import Captcha from './App'

Captcha.install = (Vue) => {
  Vue.use(VerificationCode)
  Vue.component(Captcha.name, Captcha)
}

export default Captcha
